import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import {useSelector} from "react-redux";
import {useDispatch} from "react-redux";
import {getZipCodeInfo, saveCompanyInfo} from './endpoints/action';
import {companySelector} from "./endpoints/selector";
import { 
  setInitalState
} from "./endpoints/slice";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import Error from '../common/Message/error';
import Success from "../common/Message/success";
import { useNavigate } from "react-router-dom";
import Loader from "../common/Loader";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const navigate = useNavigate();
  const timeZonesDropdownList = props.timeZonesDropdownList;
  const companyDetailsList = props.companyDetailsList;
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem('login');
  const [form, setForm] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState([]);
  const {zipCodeInfo, successMessage, errorMessage} = useSelector(companySelector);
  const [formMessage, setFormMessage] = useState('');
  const dispatch = useDispatch();
  //console.log(zipCodeInfo);
  //console.log(timeZonesDropdownList);
  const [companyInfo, setCompanyInfo] = useState({
      employerId: login.employerId,
      companyName: "",
      zipcode: "",
      city: "",
      stateName: "",
      country: "",
      streetAddress: "",
      phoneNumber: "",
      timezone: "",
      createdBy: login.appUserId,
      email: "",
  });

  //console.log(form);

  useEffect(() => {
      dispatch(setInitalState());      
  }, []);

  const formatPhoneNumber = (value) => {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
        return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    }
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
        3,
        6
    )}-${phoneNumber.slice(6, 10)}`;
  }


  
  const validateZipcode = (value) => {
    value = formatZipcode(value);
    setField('zipcode',value);
  }

  
  const formatZipcode = (value) => {
    if (!value) return value;
    const ZipcodeNumber = value.replace(/[^\d]/g, '');
    
    if (ZipcodeNumber.length <= 6)
    {
      return ZipcodeNumber;
    }
    else
    {
     return `${ZipcodeNumber.slice(0, 6)}`;
    }  
    
  }

  const setField = (field, value) => {
    if(field === 'phoneNumber') {
      value = formatPhoneNumber(value);
    }
    setForm({
      ...form,
      [field]: value
    })
    setCompanyInfo({
      ...companyInfo,
      [field]: value
    })

    if(!!errors[field]) {
      setErrors({
        ...errors,
        [field]: null
      })
    }
  }

  useEffect(() => {
    setFormMessage('');
    setForm({
      ...form,
      ['companyName']: companyDetailsList.companyName,
      ['streetAddress']: companyDetailsList.streetAddress,
      ['zipcode']: companyDetailsList.zipcode,
      ['stateName']: companyDetailsList.stateName,
      ['city']: companyDetailsList.city,
      ['phoneNumber']: companyDetailsList.phoneNumber,
      ['timezone']: companyDetailsList.timezone,
      ['email']: companyDetailsList.email,
    });

    setCompanyInfo({
      ...companyInfo,
      ['companyName']: companyDetailsList.companyName,
      ['streetAddress']: companyDetailsList.streetAddress,
      ['zipcode']: companyDetailsList.zipcode,
      ['stateName']: companyDetailsList.stateName,
      ['city']: companyDetailsList.city,
      ['phoneNumber']: companyDetailsList.phoneNumber,
      ['timezone']: companyDetailsList.timezone,
      ['email']: companyDetailsList.email,
    })
     
  }, [companyDetailsList]);

  useEffect(() => {
    if(successMessage !== null)
      setFormMessage(successMessage);
     /* navigate('/addlocations', {
      state: {
          contacts: "false",
          hideContact: true
      }
  }) */
  }, [successMessage]);

  useEffect(() => {
    if(errorMessage !== null)
      setFormMessage(errorMessage)
  }, [errorMessage]);

  const clearFields = () => {
    setForm({});
  }

  useEffect(() => {
    if(form.zipcode && form.zipcode.length === 5)
      dispatch(getZipCodeInfo(config.baseUrl, form.zipcode));
  }, [form.zipcode && form.zipcode.length === 5]);

  useEffect(() => {
    if(zipCodeInfo)
    setForm({
      ...form,
      stateName: zipCodeInfo.state,
      city: zipCodeInfo.city,
      //timezone: zipCodeInfo.timeZone
    });

    setCompanyInfo({
      ...companyInfo,
      stateName: zipCodeInfo.state,
      city: zipCodeInfo.city,
      //timezone: zipCodeInfo.timeZone
    })
    setIsDisabled(true);
  }, [zipCodeInfo]);

  const validateForm = () => {
    const {companyName, streetAddress, zipcode, stateName, city, phoneNumber, timezone, email} = form;
    const newErrors = {};
    const phoneno = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
    
    const emailPattern = "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$"

    if(!companyName || companyName === '') newErrors.companyName = "Please enter the company name"
    if(!streetAddress || streetAddress === '') newErrors.streetAddress = "Please enter the street Address"
    if(!zipcode || zipcode === '') newErrors.zipcode = "Please enter the Zip Code"
    if(!stateName || stateName === '') newErrors.stateName = "Please enter the State"
    if(!city || city === '') newErrors.city = "Please enter the City"
    if(!phoneNumber || phoneNumber === '') {
      newErrors.phoneNumber = "Please enter the Phone number"
    } else if(!phoneNumber.match(phoneno)) {
      newErrors.phoneNumber = "Phone number should be a 10 digit number"
    }
    if(!email || email === '') newErrors.email = "Please enter the Email"

    if(email!=='')
    {
      if(!email.match(emailPattern)) {
        newErrors.email = "Invalid Email format"
      }
    }

    return newErrors
  }

 console.log(companyDetailsList.jobTypeList);

  const validateAndSubmit = (e) => {
    e.preventDefault();

    const formErrors = validateForm();
    if(Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
    } else {
      dispatch(saveCompanyInfo(config.baseUrl, companyInfo));
    }

  }

  function cancel() {
    navigate('/openshifts')
  }

  return (
    <div>
      <Loader />
      <div>
        <div id="tab25">
          {
            errorMessage && <Error errorMessage={errorMessage}/>
          }
          {
            successMessage && <Success successMessage={successMessage} />
          }
          <div class="col-xl-14" id="companyForm">
              <Form autoComplete="off" noValidate onSubmit={validateAndSubmit}>
                  <Row>
                    <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="companyName">
                      <Form.Label>Main Company Name<span class="required">*</span></Form.Label>
                      <Form.Control type="text" 
                        value={form.companyName}
                        onChange={e => {
                          setField('companyName', e.currentTarget.value)
                        }}
                        placeholder="Main Company Name" 
                        isInvalid={!!errors.companyName}/>
                      <Form.Control.Feedback type="invalid">
                        {errors.companyName}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="streetAddress">
                      <Form.Label>Street<span class="required">*</span></Form.Label>
                      <Form.Control type="text" 
                        value={form.streetAddress}
                        onChange={e => {
                          setField('streetAddress', e.currentTarget.value)
                        }}
                        placeholder="Street" 
                        isInvalid={!!errors.streetAddress}/>
                      <Form.Control.Feedback type="invalid">
                        {errors.streetAddress}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row>
                   
                    <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="zipcode">
                      <Form.Label>Zip<span class="required">*</span></Form.Label>
                      <Form.Control type="text"
                         value={form.zipcode}
                         onChange={e => {
                          //setField('zipcode', e.currentTarget.value)
                          validateZipcode(e.currentTarget.value)
                         }}
                      placeholder="ZipCode" 
                      isInvalid={!!errors.zipcode}/>
                    <Form.Control.Feedback type="invalid">
                        {errors.zipcode}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="city">
                      <Form.Label>City<span class="required">*</span></Form.Label>
                      <Form.Control type="text" 
                         value={form.city}
                         onChange={e => {
                          setField('city', e.currentTarget.value)
                         }}
                        placeholder="City" 
                        isInvalid={!!errors.city}/>
                      <Form.Control.Feedback type="invalid">
                        {errors.city}
                      </Form.Control.Feedback>
                    </Form.Group> 
                  </Row>
                  <Row>
                    
                    <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="stateName">
                      <Form.Label>State<span class="required">*</span></Form.Label>
                      <Form.Control type="text" 
                        value={form.stateName}
                        onChange={e => {
                          setField('stateName', e.currentTarget.value)
                        }}
                        placeholder="State" 
                        isInvalid={!!errors.stateName}/>
                      <Form.Control.Feedback type="invalid">
                        {errors.stateName}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="phoneNumber">
                      <Form.Label>Phone<span class="required">*</span></Form.Label>
                      <Form.Control type="text" 
                        value={form.phoneNumber}
                        onChange={e => {
                          setField('phoneNumber', e.currentTarget.value)
                        }}
                        placeholder="Phone" 
                        isInvalid={!!errors.phoneNumber} />
                      <Form.Control.Feedback type="invalid">
                        {errors.phoneNumber}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row>
                   
                    <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="email">
                      <Form.Label>Email<span class="required">*</span></Form.Label>
                      <Form.Control type="text" 
                        value={form.email}
                        onChange={e => {
                          setField('email', e.currentTarget.value)
                        }}
                        placeholder="Email" 
                        isInvalid={!!errors.email} />
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </Form.Group>
                 
                    <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="timezone">
                      <Form.Label>Time Zone</Form.Label>
                      <Form.Select 
                        value={form.timezone}
                        onChange={e => {
                          setField('timezone', e.currentTarget.value)
                        }}>
                        <option value="">--Select--</option>
                        {timeZonesDropdownList.map((area, n) => (
                          <option key={`timezone_${n}`} value={area.convertionTimezone}>
                            {area.displayText}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Row>
                  <div class="card-footer text-end formButton">
                    <Button class="btn btn-success my-1" type="Submit">
                      Save
                    </Button>
                    <button type="Submit" class="btn btn-outline-primary" onClick={cancel}>Cancel</button>
                    {/* <Button variant="secondary" class="btn btn-outline-danger my-1" type="Submit" onClick={cancel}>
                      Cancel
                    </Button> */}
                  </div>
                </Form>
                {/* <div className="card-body">
                    <div className="form-group">
                        <>
                            <div className="row">
                                <div className="col-lg-4 col-md-4">
                                    <label className="form-label">Certification</label>
                                    {companyDetailsList.jobTypeList &&

                                        companyDetailsList.jobTypeList.map(cert => (
                                            <div> <label>{cert.jobTypes}</label></div>
                                        ))
                                    }
                                </div>                                
                            </div>
                        </>
                    </div>
                </div> */}
          </div>
          
        </div>        
      </div>      
    </div>
  );
};
